import { defineMessages, type MessageDescriptor } from 'react-intl';

export const surfaceMessages: Record<'resetDate' | 'requestCredits' | 'title', MessageDescriptor> =
	defineMessages({
		resetDate: {
			id: 'rovo-credits.internal.credits-surface.resetDate',
			defaultMessage: 'Resets {resetDate}.',
			description: 'Separate line in a credits popup showing the localized reset date.',
		},
		requestCredits: {
			id: 'rovo-credits.internal.credits-surface.requestCredits',
			defaultMessage: 'Request credits',
			description: 'Popup link text for requesting more Rovo credits.',
		},
		title: {
			id: 'rovo-credits.internal.credits-surface.title',
			defaultMessage: 'Rovo credits',
			description: 'Title of a notification or popup explaining Rovo credit availability.',
		},
	});
